import { Dialog } from 'primereact/dialog';
import SeeMoreIterationLogic from './SeeMoreIteration.logic';
import classes from './SeeMoreIteration.module.scss';
import { observer } from 'mobx-react';
import moment from 'moment';
import { Skeleton } from 'primereact/skeleton';

const SeeMoreIteration = ({
  visible,
  closeModal,
  opportunityID,
  handleIterationClick,
}: {
  visible: boolean;
  closeModal: () => void;
  opportunityID: number;
  handleIterationClick: (iterationId: number) => void;
}) => {
  const { isAllIterationLoading, allIterations } = SeeMoreIterationLogic(opportunityID);

  return (
    <Dialog
      header={<span style={{ color: 'var(--text-primary)' }}>Iterations</span>}
      style={{
        width: '40rem',
        maxHeight: '80vh',
        overflow: 'scroll',
        margin: 'auto',
      }}
      visible={visible}
      onHide={closeModal}
      draggable={false}
      resizable={false}
    >
      {isAllIterationLoading ? (
        <Skeleton width="100%" height="33rem"></Skeleton>
      ) : !isAllIterationLoading && allIterations?.length !== 0 ? (
        <div className={classes.seeMoreIterationContainer}>
          <table>
            <thead className={classes.tableHeading}>
              <th>Iteration</th>
              <th style={{ marginRight: '1rem' }}>Type</th>
              <th>Last Modified</th>
              <th>Status</th>
            </thead>
            <tbody>
              {allIterations &&
                allIterations.map((item, idx) => {
                  return (
                    <tr
                      className={
                        item.IsActive ? classes.iterationRow : classes.iterationRowInactive
                      }
                      onClick={() => {
                        if (item.IsActive) {
                          handleIterationClick(item.OpportunityIterationsID);
                        }
                      }}
                      key={idx}
                    >
                      <td>{item.IterationCounter ? item.IterationCounter : ' - '}</td>
                      <td className={classes.iterationType} style={{ marginRight: '1rem' }}>
                        {item.IterationType}
                      </td>
                      <td>{moment(item.LastModifiedDate.split('T')[0]).format('DD MMMM YYYY')}</td>
                      <td>{item.IsActive ? 'Active' : 'Inactive'}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {/* <div className={classes.tableHeading}>
            <p>Iteration</p>
            <p
              style={{
                paddingLeft: "1rem",
                paddingRight: "1rem",
                width: "6rem",
              }}
            >
              Type
            </p>
            <p>Last Modified</p>
            <p>Status</p>
          </div>
          {allIterations &&
            allIterations.map((item, idx) => {
              return (
                <div
                  className={
                    item.IsActive
                      ? classes.iterationRow
                      : classes.iterationRowInactive
                  }
                  onClick={() => {
                    if (item.IsActive) {
                      handleIterationClick(item.OpportunityIterationsID);
                    }
                  }}
                  key={idx}
                >
                  <p>{item.IterationCounter ? item.IterationCounter : " - "}</p>
                  <p className={classes.iterationType}>{item.IterationType}</p>
                  <p>
                    {moment(item.LastModifiedDate.split("T")[0]).format(
                      "DD MMMM YYYY"
                    )}
                  </p>
                  <p>{item.IsActive ? "Active" : "Inactive"}</p>
                </div>
              );
            })} */}
        </div>
      ) : (
        <div className={classes.noDdataContainer}>No old Iterations found.</div>
      )}
    </Dialog>
  );
};

export default observer(SeeMoreIteration);
